// extracted by mini-css-extract-plugin
module.exports = {"tk-zuume-edge":"typekit_tk-zuume-edge__s8x7O"};